module.exports = __webpack_public_path__ + "shri_yantra.cbe68e884f5f9a57b399.png";